import {
  Link as LinkIcon,
  Star as RatingIcon,
  RotateCw as RefreshIcon,
  Eye as WatchListIcon,
} from 'lucide-react';
import React from 'react';
import { getRatingTier } from '../helpers';
import { IconButton } from './Button';

/**
 * RatingActionButton - Shows rating with icon if set, otherwise icon button only
 */
export function RatingActionButton({ userRating, onClick }) {
  const ratingTier = userRating ? getRatingTier(userRating * 20) : '';
  const hasRating = !!userRating;

  if (!hasRating) {
    // Icon button variant for modal or when no rating
    return (
      <IconButton
        className={`action-button action-button--rating${
          ratingTier ? ` action-button--rating-${ratingTier}` : ''
        }`}
        title={hasRating ? 'Edit rating' : 'Set rating'}
        aria-label={
          hasRating
            ? 'Edit your rating for this movie'
            : 'Set your rating for this movie'
        }
        onClick={onClick}
      >
        <RatingIcon size={20} fill={hasRating ? 'currentColor' : 'none'} />
      </IconButton>
    );
  }

  // Rating display variant for movie card when rating exists
  return (
    <div
      className={`movie-card__user-rating movie-card__user-rating--${ratingTier}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-label={`Your rating: ${userRating} stars`}
    >
      <RatingIcon size={16} fill="currentColor" />
      <span>{userRating}</span>
    </div>
  );
}

/**
 * WatchlistActionButton - Toggle watchlist status
 */
export function WatchlistActionButton({ isWatchlisted, onClick }) {
  return (
    <IconButton
      className={`action-button action-button--watchlist${
        isWatchlisted ? ' active' : ''
      }`}
      title="Toggle watchlist"
      aria-label={isWatchlisted ? 'Remove from watchlist' : 'Add to watchlist'}
      onClick={onClick}
    >
      <WatchListIcon size={20} fill="none" />
    </IconButton>
  );
}

/**
 * RefreshActionButton - Refresh movie data
 */
export function RefreshActionButton({ onClick }) {
  return (
    <IconButton
      className="action-button action-button--refresh"
      title="Refresh movie data"
      aria-label="Refresh movie data from external sources"
      onClick={onClick}
    >
      <RefreshIcon size={20} />
    </IconButton>
  );
}

/**
 * OpenInNewPageActionButton - Open movie in new page/tab
 */
export function OpenInNewPageActionButton({ movieId }) {
  return (
    <IconButton
      className="action-button action-button--open"
      title="Open in new page"
      aria-label="Open in new page"
      onClick={() =>
        window.open(`/m/${movieId}`, '_blank', 'noopener,noreferrer')
      }
    >
      <LinkIcon size={20} />
    </IconButton>
  );
}
